module.exports = __webpack_public_path__ + "img/shuxue.a25e4a0f.png";